// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Grid, Segment, Container, Image } from 'semantic-ui-react'
import charts from '../assets/charts.png'
import rss from '../assets/rss.png'

export default class MoreFeatures extends Component {
  render () {
    return (
      <Container className='mtb'>
        <h3 className='center mb'>Recentely added 🎉</h3>
        <Grid verticalAlign='middle' stackable centered>
          <Grid.Column width='8'>
            <Segment padded>
              <Image fluid  src={rss} />
              <h4 style={{ fontWeight: 700 }}>RSS Feed</h4>
              <p>Convert any RSS feed to native components in few clicks</p>
            </Segment>
          </Grid.Column>
          <Grid.Column width='8'>
            <Segment padded>
              <Image fluid  src={charts} />
              <h4 style={{ fontWeight: 700 }}>Charts</h4>
              <p>Display your dataset using beautiful charts and graphs</p>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    )
  }
}
